import { z } from 'zod';

export const AreaSchema = z.object({
	name: z
		.string()
		.min(1, 'Nome da área é obrigatório')
		.max(120, 'Nome deve ter no máximo 120 caracteres'),
	culture: z.enum(['cafeArabica', 'cafeConilon'], { error: 'Cultura é obrigatória' }),
	irrigation: z.enum(['none', 'drip', 'sprinkler', 'microSprinkler', 'pivot'], {
		error: 'Irrigação é obrigatória',
	}),
});

export type AreaSchemaType = z.infer<typeof AreaSchema>;
